import { render, staticRenderFns } from "./BuildCoverage.vue?vue&type=template&id=013dee32&scoped=true"
import script from "./BuildCoverage.vue?vue&type=script&lang=js"
export * from "./BuildCoverage.vue?vue&type=script&lang=js"
import style0 from "./BuildCoverage.vue?vue&type=style&index=0&id=013dee32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013dee32",
  null
  
)

export default component.exports